var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0841 6.60002V10.8917C16.0841 13.4583 14.6174 14.5583 12.4174 14.5583H5.09245C4.71745 14.5583 4.35911 14.525 4.02578 14.45C3.81745 14.4167 3.61745 14.3583 3.43411 14.2917C2.18411 13.825 1.42578 12.7417 1.42578 10.8917V6.60002C1.42578 4.03335 2.89245 2.93335 5.09245 2.93335H12.4174C14.2841 2.93335 15.6258 3.72502 15.9841 5.53335C16.0424 5.86668 16.0841 6.20835 16.0841 6.60002Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5837 9.09999V13.3917C18.5837 15.9583 17.1171 17.0583 14.9171 17.0583H7.59206C6.97539 17.0583 6.41706 16.975 5.93372 16.7917C4.94206 16.425 4.26706 15.6667 4.02539 14.45C4.35872 14.525 4.71706 14.5583 5.09206 14.5583H12.4171C14.6171 14.5583 16.0837 13.4583 16.0837 10.8917V6.59999C16.0837 6.20833 16.0504 5.85833 15.9837 5.53333C17.5671 5.86666 18.5837 6.98333 18.5837 9.09999Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98242 6.91665V10.5833M13.5174 6.91665V10.5833M8.74742 10.95C9.3309 10.95 9.89048 10.7182 10.3031 10.3056C10.7156 9.89304 10.9474 9.33346 10.9474 8.74999C10.9474 8.16651 10.7156 7.60693 10.3031 7.19435C9.89048 6.78177 9.3309 6.54999 8.74742 6.54999C8.16395 6.54999 7.60437 6.78177 7.19179 7.19435C6.77921 7.60693 6.54742 8.16651 6.54742 8.74999C6.54742 9.33346 6.77921 9.89304 7.19179 10.3056C7.60437 10.7182 8.16395 10.95 8.74742 10.95Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.4568abae2743b5648322485d2f21550b.svg";
export { ForwardRef as ReactComponent };